// extracted by mini-css-extract-plugin
export default {"tab-list":"StyledTab_tab-list__UqkRz","tab-panel":"StyledTab_tab-panel__HzGB8"};